import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { Search /*, Settings2*/ } from 'lucide-react'
import { ProtectedRoute } from '@/components/ProtectedRoute'
import { lazyRoute } from '../routeHelpers'
import type { FrontendFeature } from '../types'

// Route-level code splitting — each catalog page lands in its own chunk
// so that visiting `/projects` doesn't pull the browse + PDP + admin
// bundles, and the admin ops page (which is heavy) is loaded on demand.
const CatalogBrowsePage = lazy(() => import('@/features/catalog/browse/pages/CatalogBrowsePage'))
const CatalogPdpPage = lazy(() => import('@/features/catalog/browse/pages/CatalogPdpPage'))
const AdminCatalogOpsPage = lazy(() => import('@/features/catalog/admin-ops/pages/AdminCatalogOpsPage'))

const feature: FrontendFeature = {
  navItems: [
    {
      path: '/catalog',
      label: 'Browse catalog',
      icon: Search,
      requiredPermissions: ['catalog:browse'],
    },
    // Inventory is its own top-level feature (`features/inventory`) gated by the
    // `inventory` flag — it is not a catalog sub-area.
    // { path: '/admin/catalog', label: 'Catalog ops', icon: Settings2, requiredPermissions: ['admin:catalog:reindex'] },
  ],
  routes: [
    <Route
      key="catalog-browse"
      path="/catalog"
      element={
        <ProtectedRoute requiredPermissions={['catalog:browse']}>
          {lazyRoute(<CatalogBrowsePage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="catalog-pdp"
      path="/catalog/product/:id"
      element={
        <ProtectedRoute requiredPermissions={['catalog:browse']}>
          {lazyRoute(<CatalogPdpPage />)}
        </ProtectedRoute>
      }
    />,
    <Route
      key="admin-catalog-ops"
      path="/admin/catalog"
      element={
        <ProtectedRoute requiredPermissions={['admin:catalog:reindex']}>
          {lazyRoute(<AdminCatalogOpsPage />)}
        </ProtectedRoute>
      }
    />,
  ],
}

export default feature
